import LayerSettings from "./LayerSettings";

class HighlightFeatureLayer extends LayerSettings {
  constructor(layer_data, layer_group_id) {
    super(layer_data, layer_group_id);

    this.uuid = layer_data.uuid;
    this.id = `layer-highlight-feature-${this.uuid}`;
    this.layer_group_id = layer_group_id;
    this.layer = layer_data.layer;
    this.display = false;
  }

  getActionsOnRightClick = () => {
    console.log("DefaultLayer getActionsOnRightClick");
    return [];
  };
}

export { HighlightFeatureLayer };
